import { api } from "../adapters/api";

const resource = "api/v1/notifications";
const authHeader = () => ({ "Authorization": "Bearer " + localStorage.getItem("jwtToken") });

export interface NotificationItem {
    id: string;
    title: string;
    message: string;
    type: string;
    read: boolean;
    applicationId?: string;
    createdAt: string;
}

// Backend serializes LocalDateTime without a timezone; the server runs in UTC, so we
// treat the value as UTC (matching how the mobile app parses the same field). Without
// this, the browser parses it as local time and relative timestamps are off by the UTC offset.
export const parseServerDate = (iso: string): Date =>
    new Date(/[zZ]$|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + "Z");

// Notification titles already contain an emoji; the list/bell render a type icon separately,
// so strip the emoji from the title to avoid showing it twice.
export const stripEmoji = (text: string): string =>
    text.replace(/[\p{Extended_Pictographic}\u{FE0F}]/gu, "").trim();

// Fired whenever notifications change so independently-mounted components (e.g. the bell
// badge and the full page) can stay in sync without a shared store.
export const NOTIFICATIONS_CHANGED_EVENT = "jobbin:notifications-changed";
const emitChanged = () => window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));

export const getNotifications = (): Promise<NotificationItem[]> =>
    api.get(resource, authHeader()).then((res: any) => res.json());

export const getUnreadCount = (): Promise<{ count: number }> =>
    api.get(resource + "/unread-count", authHeader()).then((res: any) => res.json());

export const markAsRead = (id: string): Promise<void> =>
    api.patch(resource + "/" + id + "/read", null, authHeader()).then(() => { emitChanged(); });

export const markAllAsRead = (): Promise<void> =>
    api.patch(resource + "/read-all", null, authHeader()).then(() => { emitChanged(); });

export const deleteNotification = (id: string): Promise<void> =>
    api.delete(resource + "/" + id, authHeader()).then(() => { emitChanged(); });
